var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-section-header',{staticClass:"center-content",attrs:{"data":_vm.heading}}),_c('fragment',[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":"https://recruitcrm.io/talent_pool_submission/campuskraft"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }